import React from 'react';
import { useSelector } from 'react-redux';

import Store, { actions } from '@store';
import Viewport from 'src/components/Viewport/Viewport';
import ReactAppBuilder from 'src/utils/react-app-builder';
import getActivePage from '../../helpers/active-page-details';

class TextOverflowApp extends ReactAppBuilder {
  constructor ({ appId, targetNodeSelector }) {
    super({ appId, targetNodeSelector });
  }

  getHiddenTextUpdatedPagesContent (pagesContent) {
    // Must render hidden texts before getting updated pages content
    // Hidden texts are texts on other pages linked to texts on active page

    INKIVE.TextOverflowFactory.renderHiddenTextsOverflow();
    const additionalTexts = INKIVE.AdvancedOrderedListFactory.renderHiddenTexts();

    const hiddenTextUpdatedPagesContent = INKIVE.TextOverflowFactory.getUpdatedPagesContentWithHiddenText(pagesContent, additionalTexts);

    return hiddenTextUpdatedPagesContent;
  }

  loadTextOverflow (pages, pagesOrder) {
    const activePage = getActivePage();

    const activePageContent = INKIVE.EditorFacade.editor.getSvgString();
    const allPagesContent = { ...pages, [activePage.id]: { content: activePageContent } };

    const hiddenTextUpdatedPagesContent = this.getHiddenTextUpdatedPagesContent(allPagesContent);

    for (const id of pagesOrder) {
      if (id in hiddenTextUpdatedPagesContent) {
        const content = hiddenTextUpdatedPagesContent[id];
        INKIVE.PageFactory.savePageState(id, content);
        Store.dispatch(actions.page.setPage({ id, content }));
      } else if (!pages[id]?.content) {
        Store.dispatch(actions.page.fetchPage({ id }));
      } else if (id === activePage.id) {
        Store.dispatch(actions.page.setPage(activePage));
      }
    }
  }

  openTextOverflow () {
    INKIVE.TextOverflowFactory.setChange(true);
    INKIVE.hasEditorUnsavedChanges = true;
    const state = Store.getState();

    const locked = state.navigation.textOverflow.locked;
    const pages = state.page;
    const pagesOrder = state.editor.pagesOrder;

    if (locked) return;

    Store.dispatch(actions.page.setPage(getActivePage()));
    Store.dispatch(actions.navigation.toggleLoadingTextOverflow());

    this.appNode.classList.add('visible');
    Store.dispatch(actions.navigation.openTextOverflow());
    this.loadTextOverflow(pages, pagesOrder);

    Store.dispatch(actions.navigation.toggleLoadingTextOverflow());
  }

  closeTextOverflow () {
    this.appNode.classList.remove('visible');
    Store.dispatch(actions.navigation.closeTextOverflow());
  }

  async mountApp () {
    await super.mountApp(this.App);
  }

  App = () => {
    const { visible, loading } = useSelector(state => state.navigation.textOverflow);

    return <Viewport loading={loading} onClose={() => this.closeTextOverflow()} visible={visible} />;
  };
}

export default new TextOverflowApp({
  appId: 'text-overflow-mount-point',
  targetNodeSelector: 'body'
});
